<div class="cf-templates-dialog">
  <div mat-dialog-title oneDialogTitle>
    <span i18n="@@input-dialog-example.title">Message templates</span>
   </div>
  <div mat-dialog-content oneDialogContent class="import-dialog-content">
    <!-- (isFeedbackOptionAdded)="feedbackOptionAdded($event)"  -->
    <dl-msg-attachment-template [isNewFromTemplate]="isNewFromTemplate" [addRowData]="newMessageTemplate" [displayedColumns]="templateColumn" [tableData]="templateData" (isMessageRowSelected)="getSelectedRowInTemplate($event)" ></dl-msg-attachment-template>
  </div>
  <div mat-dialog-actions oneDialogActions class="import-dialog-actions">
    <button
      one-secondary-button
      mat-stroked-button     
       [mat-dialog-close]="true"
    > Cancel
    </button>
    <button color="primary" [disabled]="isNtBtnDisabled" mat-flat-button i18n="@@input-dialog-example.ok-btn" (click)="openNewTemplateAction()" >
      New template
    </button>
    <button color="primary" [disabled]="isAffBtnDisabled" [mat-dialog-close]="data" mat-flat-button i18n="@@input-dialog-example.ok-btn" (click)="addTemplateToForm()" >
      Select
    </button>
  </div>
</div>
